import React from "react";
import PropTypes from "prop-types";

import { Button } from "semantic-ui-react";

export function ImportedSyncEntityModalButtons({
  loading,
  disabled,
  onClose,
  onSubmit,
}) {
  return (
    <div style={{ display: "flex" }}>
      <Button
        style={{ flexGrow: 1 }}
        basic
        disabled={loading}
        content="Cancel"
        type="button"
        onClick={onClose}
      />
      <Button
        disabled={loading || disabled}
        loading={loading}
        style={{ flexGrow: 1 }}
        primary
        content="Save"
        onClick={onSubmit}
      />
    </div>
  );
}

ImportedSyncEntityModalButtons.propTypes = {
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

ImportedSyncEntityModalButtons.defaultProps = {
  loading: false,
  disabled: false,
};

export default ImportedSyncEntityModalButtons;
